"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var groups = /** @class */ (function () {
    function groups() {
    }
    groups.group_id_root = "group-root-id";
    groups.group_id_main = "group-main-id";
    groups.group_id_bonuses = "group-bonuses-id";
    groups.group_id_gateways = "group-gateways-id";
    groups.group_id_users = "group-users-id";
    groups.group_id_finance = "group-finance-id";
    groups.group_id_content = "group-content-id";
    groups.group_id_config = "group-config-id";
    groups.group_id_partner = "group-partner-id";
    groups.group_id_report = "group-report-id";
    groups.group_id_support = "group-support-id";
    groups.group_id_security = "group-security-id";
    groups.group_id_paysystem = "group-paysystem-id";
    groups.groups_avail = [
        groups.group_id_main,
        groups.group_id_bonuses,
        groups.group_id_gateways,
        groups.group_id_users,
        groups.group_id_finance,
        groups.group_id_content,
        groups.group_id_config,
        groups.group_id_partner,
        groups.group_id_report,
        groups.group_id_support,
        groups.group_id_security,
        groups.group_id_paysystem
    ];
    return groups;
}());
exports.groups = groups;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/shared/includes/groups.ts
// module id = 766
// module chunks = 0